import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Screenshot = makeShortcode("Screenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`If you install a package, and it prints a deprecation message, we recommend following the instructions, if possible.`}</p>
    <p>{`That might mean updating to a new version, or updating your package dependencies.`}</p>
    <Screenshot src="/packages-and-modules/getting-packages-from-the-registry/package-deprecated.png" alt="Screenshot of a deprecated package showing that it is no longer supported" mdxType="Screenshot" />
    <p>{`A deprecation message doesn't always mean the package or version is unusable; it may mean the package is unmaintained and will no longer be updated by the publisher.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      